export const categories = [
  {
    id: 1,
    title: " 🏫 Education",
    icon: require("../assets/images/healthcare.png"),
    color: "#FFBF00",
  },
  {
    id: 2,
    title: "🏥 Healthcare",
    icon: require("../assets/images/healthcare.png"),
    color: "#C1292E",
  },
  {
    id: 3,
    title: "🛒 Shopping",
    icon: require("../assets/images/shopping.png"),
    color: "#2274A5",
  },
  {
    id: 4,
    title: "🍔 Food",
    icon: require("../assets/images/food.png"),
    color: "#32936F",
 
  },
  {
    id: 5,
    title: "🍿 Entertainment",
    icon: require("../assets/images/entertainment.png"),
    color: "#111",
  },
  {
    id: 6,
    title: "🏖️ Travel",
    icon: require("../assets/images/entertainment.png"),
    color: "#4EFFEF",
  },
  {
    id: 7,
    title: "✅ Other",
    icon: require("../assets/images/entertainment.png"),
    color: "#D7FD00",
  },
];
